import React from "react";
import ReviewItem from "components/Dashboard/ReviewsList/ReviewItem";
import reviewListStyles from "components/Dashboard/ReviewsList/style.module.scss";
import { normalizeWelcomeDrawerReviewDoc } from "pages/Welcome/welcomeDrawerReviewDoc";
import { resolveWelcomeDrawerReviewDashboardId } from "pages/Welcome/welcomeDrawerReviewFeedbackTopics";
import { WELCOME_DRAWER_DROPDOWN_OVERLAY_CLASS } from "pages/Welcome/welcomeReviewsDrawerProps";

function hasAlphabet(str) {
  return /[A-Za-z]/.test(String(str ?? ""));
}

/**
 * Dashboard ReviewsList ReviewItem row for Welcome / KPI side drawers.
 */
export default function WelcomeDrawerReviewItem({
  review,
  highlightEntry = null,
  feedbackModeEnabled = false,
  feedbackState,
  allReviews,
  getHighlights,
  setReviewsLoading,
}) {
  const doc = normalizeWelcomeDrawerReviewDoc(review) || review;
  const dateGpid = doc?.date_gpid;
  if (!dateGpid) return null;

  const sequences = highlightEntry?.sequences ?? [];
  const classifierSequences = highlightEntry?.classifier_sequences ?? [];
  const sentiment = highlightEntry?.sentiment ?? doc?.num_sentiment ?? "";
  const intentRaw = highlightEntry?.intent ?? doc?.num_intent ?? doc?.drawer_intent;
  const intents =
    typeof intentRaw === "string" ? intentRaw.split(".")[0] : intentRaw;
  const associatedTopics = highlightEntry?.associated_topics ?? [];

  const {
    selectionIsFromSameReview,
    setSelectionIsFromSameReview,
    allReviewsIntents,
    setAllReviewsIntents,
    pageChanged,
    setPageChanged,
    prevDeletionKey,
    setPrevDeletionKey,
    prevSelectionKey,
    setPrevSelectionKey,
    highlightedText,
    setHighlightedText,
    deletedTopics,
    setDeletedTopics,
    deletedIntents,
    setDeletedIntents,
    publish,
    setPublish,
    openCase,
    setOpenCase,
    action,
    setAction,
    prevClassifierKey,
    setPrevClassifierKey,
    decisionTags,
    setDecisionTags,
    allTopics,
    levelWiseTopics,
    isTopicLearningBased,
  } = feedbackState;

  return (
    <div className={reviewListStyles.forAllReviewsStyle}>
      <ReviewItem
        text={doc.text}
        title={doc.title}
        date={doc.timestamp}
        sentiment={sentiment}
        intents={intents}
        sequences={sequences}
        classifierSequences={classifierSequences}
        relatedTopics={associatedTopics}
        rate={doc.num_rating}
        shared={false}
        getHighlights={getHighlights}
        allTopics={allTopics}
        levelWiseTopics={levelWiseTopics}
        setReviewsLoading={setReviewsLoading}
        displayFeedbackArea={feedbackModeEnabled}
        currentDashboardHash={String(resolveWelcomeDrawerReviewDashboardId(doc) ?? "")}
        dashboardIdOverride={resolveWelcomeDrawerReviewDashboardId(doc)}
        internalId={doc.internalId || doc.internal_id}
        prevDeletionKey={prevDeletionKey}
        setPrevDeletionKey={setPrevDeletionKey}
        prevSelectionKey={prevSelectionKey}
        setPrevSelectionKey={setPrevSelectionKey}
        highlightedText={highlightedText}
        setHighlightedText={setHighlightedText}
        deletedTopics={deletedTopics}
        setDeletedTopics={setDeletedTopics}
        deletedIntents={deletedIntents}
        setDeletedIntents={setDeletedIntents}
        Gpid={doc.gpid || dateGpid?.split?.("_")?.[1]}
        date_gpid={dateGpid}
        disableChecks={false}
        feedbackModeEnabled={Boolean(feedbackModeEnabled)}
        publish={publish}
        openCase={openCase}
        action={action}
        setPublish={setPublish}
        setOpenCase={setOpenCase}
        setAction={setAction}
        prevClassifierKey={prevClassifierKey}
        setPrevClassifierKey={setPrevClassifierKey}
        restaurant={doc.pivot}
        boardDataSrc
        showCustomTopicLabel
        showAiTopicLabel
        showCustomTopicParentLabel
        showPivotsInReviews
        allReviews={allReviews}
        decisionTags={decisionTags}
        setDecisionTags={setDecisionTags}
        isTopicLearningBased={isTopicLearningBased}
        selectionIsFromSameReview={selectionIsFromSameReview}
        setSelectionIsFromSameReview={setSelectionIsFromSameReview}
        allReviewsIntents={allReviewsIntents}
        setAllReviewsIntents={setAllReviewsIntents}
        pageChanged={pageChanged}
        setPageChanged={setPageChanged}
        reviewPlatformId={doc.num_platform}
        fraud={doc.fraud}
        engagements={{
          likes: hasAlphabet(doc.likes) ? doc.likes : parseInt(doc.likes, 10),
          comments: hasAlphabet(doc.comment_count)
            ? doc.comment_count
            : parseInt(doc.comment_count, 10),
          retweets: hasAlphabet(doc.retweet_count)
            ? doc.retweet_count
            : parseInt(doc.retweet_count, 10),
          views: hasAlphabet(doc.views_count)
            ? doc.views_count
            : parseInt(doc.views_count, 10),
        }}
        url={doc.trustpilot_url}
        dropdownGetPopupContainer={() => document.body}
        dropdownOverlayClassName={WELCOME_DRAWER_DROPDOWN_OVERLAY_CLASS}
      />
    </div>
  );
}
